import { createSelector } from 'reselect';
import { isActionInList } from '../reducers';

export const getAllPendingPromises = (
  state,
  { nameInState = 'pendingPromises' }
) => {
  const defaultState = state || { [nameInState]: {} };
  return defaultState[nameInState];
};

export const promisesPropSelector = (
  _,
  {
    promises = {
      includePromises: [],
      excludePromises: [],
    },
  }
) => promises;

// get pending promises that are included but not excluded
export const getPendingPromises = createSelector(
  [getAllPendingPromises, promisesPropSelector],
  (pendingPromises, promises = {}) => {
    // extract included and excluded promises
    const { includePromises = [], excludePromises = [] } = promises;

    if (!includePromises.length && !excludePromises.length) {
      // filter out empty action types
      return Object.keys(pendingPromises).reduce((acc, curr) => {
        const hasKeys = Object.keys(pendingPromises[curr]).length;
        return hasKeys ? { ...acc, [curr]: pendingPromises[curr] } : acc;
      }, {});
    }

    return Object.keys(pendingPromises).reduce((accPromises, currType) => {
      const filteredIds = Object.keys(
        pendingPromises[currType]
      ).reduce((accIds, currId) => {
        const meta = pendingPromises[currType][currId];
        const action = { type: currType, meta };
        const isIncluded = includePromises.length
          ? isActionInList(action, includePromises)
          : true;
        const isExcluded = excludePromises.length
          ? isActionInList(action, excludePromises)
          : false;
        return isIncluded && !isExcluded
          ? { ...accIds, [currId]: meta }
          : accIds;
      }, {});
      const hasKeys = Object.keys(filteredIds).length;
      return hasKeys
        ? { ...accPromises, [currType]: filteredIds }
        : accPromises;
    }, {});
  }
);

export const getIsPromisePending = createSelector(
  [getAllPendingPromises, promisesPropSelector],
  (pendingPromises, promises = {}) => {
    const { includePromises = [], excludePromises = [] } = promises || {};

    if (!includePromises.length && !excludePromises.length) {
      return false;
    }

    return Object.keys(pendingPromises).some(actionType =>
      Object.keys(pendingPromises[actionType]).some(actionId => {
        const action = {
          type: actionType,
          meta: pendingPromises[actionType][actionId],
        };
        const isIncluded = includePromises.length
          ? isActionInList(action, includePromises)
          : true;
        const isExcluded = excludePromises.length
          ? isActionInList(action, excludePromises)
          : false;
        return isIncluded && !isExcluded;
      })
    );
  }
);



// WEBPACK FOOTER //
// ./src/redux-modules/pending-promises/selectors/index.js